export const volumesMockData = {
  id: 5088,
  name: 'Sample Volume',
  courseId: 3339,
  position: 0,
  commentCount: 0,
  visible: true,
  versionId: null,
  active: true,
  isFinal: false,
  createdAt: '2025-06-16T12:35:22.281Z',
  updatedAt: '2025-06-16T12:35:22.281Z',
  deletedAt: null,
  hasEditAccess: true,
  completeVideoToNavigate: false,
  sectionsOrder: ['MAIN_CONTENT', 'INITIAL_THOUGHTS', 'EXPERT_RESOURCES', 'NEW_INSIGHTS', 'TEST', 'SURVEY'],
  chapters: [
    {
      id: 10110,
      name: 'Sample Chapter',
      content: '',
      title: null,
      showChapter: true,
      volumeId: 5088,
      position: 0,
      commentCount: 0,
      visible: true,
      versionId: null,
      active: true,
      allowComment: true,
      isFinal: false,
      createdAt: '2025-06-16T12:35:22.290Z',
      updatedAt: '2025-06-16T12:35:22.290Z',
      deletedAt: null,
      chapterCategoriesStatus: {
        sectionsCount: 2,
        initialThoughts: false,
        story: true,
        resources: false,
        newInsights: false,
        assessment: false,
        chapterId: 10110,
        passed: 1,
      },
      fileManagerMetaId: null,
      sections: {
        initialThoughts: false,
        newInsights: false,
        expertResources: false,
        test: false,
        survey: true,
      },
      chapterSection: [
        {
          id: 1,
          name: 'Sample Story',
          value: 'story',
          key: 'mc',
          icon: 'book',
        },
        {
          id: 6,
          name: 'Sample Survey',
          value: 'survey',
          key: 's',
          icon: 'survey',
        },
      ],
      isTestComplete: true,
      userContentResources: [],
      areResourcesComplete: true,
    },
  ],
};
